import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';

import BriefIcon from './layout/hero/BriefIcon';
import GalleryGridx2 from './layout/portfolio/GalleryGridx2';
import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx3 from './layout/portfolio/ImageGridx3';
import VideoGridFront from './layout/portfolio/VideoGridFront';
import WarpLarge from './layout/warp/WarpLarge';
import NextUp from './layout/warp/NextUp';

import PenIcon from './asset/PenIcon';
import Front from './img/personalProject/TheCollage.mp4';

import geometry_1 from './img/personalProject/geometry_1@2x.png';
import geometry_2 from './img/personalProject/geometry_2@2x.png';
import geometry_3 from './img/personalProject/geometry_3@2x.png';

import drawing_1 from './img/personalProject/drawing_1@2x.png';
import drawing_2 from './img/personalProject/drawing_2@2x.png';

import coding_1 from './img/personalProject/hodori@2x.jpg';


// Summary
const companyInfo = {
  title: "Design for fun.",
  name: "Generative Art",
  themeColor: "#ffffff",
  themeTextColor: "#4C55CB",
  frontImage: Front,
  role: "Unlimited :)",
  fields: "Designing, creative coding, drawing",
  time: "1998 – Forever",
}

// how I stated working at the company
const workContent =
  {
    description: "Outside of work, I enjoy learning about programming, engineering, psychology, or anything interpretive. Finding a way to interpret completely different areas with my design knowledge is great fun. Afterwards, I often share the outcome as an article or a presentation."
  };

// Project case study
const geometry = {
  summary: "Geometry",
  titleIcon: PenIcon,
  title: "I love to use geometry and mathmatics.",
  paragraph: "It may sounds really odd, I used to hate maths when I was a student. Since I realised the essence of design is based on geometry, somehow it became really fun to create something with mathematical knowledge.",
  themeColor: '#292C34',
  textColor: '#ffffff',
}

const drawing = {
  summary: "Illustration",
  titleIcon: PenIcon,
  title: "Because an image doesn't need words.",
  paragraph: "If there is one thing that never changes in my life, it must be drawing. Everything can be a drawing tool for me, sketch, photoshop or even lines of code. I like to create poetic images that can express feelings.",
  themeColor: '#ffffff',
  textColor: '',
}

const coding = {
  summary: "Generative art",
  titleIcon: PenIcon,
  title: "Creative coding",
  paragraph: "I've been enjoying creating images with code. What made me captivated was that programing language has the ability to capture the history of thoughts. Adding a perfect geomtrical detail with Processing is one of my favourite things.",
  themeColor: '#292C34',
  textColor: '#ffffff',
}

const metatag = {
  title: "Generative Art ✴︎ Personal Project",
  author: "Jinju Jang",
  url: "http://jinju.io/personal",
  description: workContent.description,
  image: "http://jinju.io" + drawing_1,
}

class PortfolioPersonal extends Component {
  render() {
    return (
      <div>
        {/*Meta data*/}
        <Helmet>
         <meta charSet="utf-8"/>
         <title>{metatag.title}</title>
         <meta name="author" content="Jinju Jang"/>
         <meta name="description" content={metatag.description}/>

         {/*-- Google / Search Engine Tags --*/}
         <meta itemprop="name" content={metatag.title}/>
         <meta itemprop="description" content={metatag.description}/>
         <meta itemprop="image" content={metatag.image}/>

         {/*-- Open Graph / Facebook --*/}
         <meta property="og:url" content={metatag.url}/>
         <meta property="og:type" content="website"/>
         <meta property="og:title" content={metatag.title} />
         <meta property="og:description" content={metatag.description}/>
         <meta property="og:image" content={metatag.image}/>

         {/*-- Twitter --*/}
         <meta name="twitter:card" content="summary_large_image"/>
         <meta name="twitter:title" content={metatag.title}/>
         <meta name="twitter:description" content={metatag.description}/>
         <meta name="twitter:image" content={metatag.image}/>
        </Helmet>

        <Navigation />
        {/*Front page*/}
        <VideoGridFront first={Front} title={companyInfo.title} themeColor={companyInfo.themeColor} textColor={companyInfo.themeTextColor}/>
        {/*Position summary*/}
        <ProjectInfo title={companyInfo.name} role={companyInfo.role} fields={companyInfo.fields} description={workContent.description} time={companyInfo.time}/>

        {/*----- geometry ------*/}
        <ImageGridx3
          first={geometry_1}
          second={geometry_2}
          third={geometry_3}
          innerDescription={<BriefIcon summary={geometry.summary} titleIcon={<PenIcon color={geometry.textColor}/>}
          title={geometry.title}
          caption={geometry.title}
          paragraph={geometry.paragraph} textColor={geometry.textColor}/>}themeColor={geometry.themeColor} true/>

        {/*----- drawing ------*/}
          <GalleryGridx2
            first={drawing_1}
            second={drawing_2}
            innerDescription={<BriefIcon summary={drawing.summary} titleIcon={<PenIcon color={drawing.textColor}/>}
            title={drawing.title}
            caption={drawing.title}
            paragraph={drawing.paragraph} textColor={drawing.textColor}/>}themeColor={drawing.themeColor} true/>

          {/*----- coding ------*/}
          <ImageGridx1
            first={coding_1}
            innerDescription={<BriefIcon summary={coding.summary} titleIcon={<PenIcon color={coding.textColor}/>}
            title={coding.title}
            caption={coding.title}
            paragraph={coding.paragraph} textColor={coding.textColor}/>}themeColor={coding.themeColor} false/>

        <NextUp
          previous="About me"
          previousURL="/About"
          next="Monoshift"
          nextURL="/monoshift"
        />
        <WarpLarge/>
        <Footer/>
      </div>
    );
  }
}

export default PortfolioPersonal;



// WEBPACK FOOTER //
// ./src/PortfolioPersonalWork.js